function formatContentJson (contentJson, phaseIndexes) {
  return {
    name: contentJson.name,
    customer: contentJson.customer,
    responsible: contentJson.responsible,
    description: contentJson.description,
    comment: contentJson.comment,
    phases: contentJson.phases.filter(phase => (phaseIndexes && phaseIndexes.includes(phase.index)) || !phaseIndexes).map(phase => {
      return {
        code: phase.code,
        name: phase.name,
        goals: phase.goals.filter(goal => goal.selected).sort((a, b) => a.code - b.code).map(goal => {
          return {
            code: goal.code,
            tasks: goal.tasks.filter(task => task.selected || task.custom).map(task => {
              return {
                code: task.code,
                completedPct: task.completedPct,
                custom: task.custom,
                description: task.description,
                how: task.how,
                title: task.title,
                what: task.what,
                negative: task.negative
              }
            })
          }
        })
      }
    })
  }
}

export default formatContentJson
